import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import getDecryptData from '../../../helper/getDecryptData';
 
import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';


const Account = () => {



  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isLoginFromLocalStorage = localStorage.getItem('token') ? true : false;
  const isLoginFromLocalStorage =  getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const [isLoginForm, setIsLoginForm] = useState(true); // State to manage which form to display

  const [IfLogin, setIfLogin] = useState(true); // State to manage which form to display



  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState); // Toggle between login and signup forms
  };


  useEffect(() => {
    // console.log(isLoginFromLocalStorage, 'isLoginFromLocalStorage')

    const checkUserToken = async () => {
      console.log('Effect is running');
      // Check if this is printed multiple times
     
      // const usertoken = localStorage.getItem('token');

      const usertoken =  getCookie('token');
      
      if (!usertoken) {
        toast.error("Please Login First");
        navigate('/');

      }

    }
    checkUserToken();
  }, [dispatch, navigate]);




  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');
  const currentUserId = getDecryptData()?._id;

  const getUserOrders = async () => {
    const decryptdatajson = getDecryptData();
    const userId = decryptdatajson?._id;

    if (!userId) {
      toast.error("Please Login First");
      navigate('/login');
      return;
    }

    try {
      const { data } = await axiosInstance.get(`/user-orders/${userId}`);
      // console.log(id);
      if (data?.success) {
        const odooOrders = (data?.userOrder.orders || []).filter(
          (order) => order.odooOrder || order.odooOrderId || order.odooOrderName
        );
        setOrder(odooOrders);
        setOrderPlace(odooOrders.length)
      }
      setIsLoading(false); // Set loading state to false after fetching data
      setIfLogin(false)
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error

    }
  };

  useEffect(() => {
    // This useEffect runs whenever the 'blog' state variable changes
    // console.log(Order); // Log the updated 'blog' state
  }, [Order]); // Dependency array with 'blog' ensures the effect runs when 'blog' state changes


  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  const formatOdooState = (state) => {
    const labels = {
      draft: 'Quotation',
      sent: 'Quotation Sent',
      sale: 'Sales Order',
      done: 'Locked',
      cancel: 'Cancelled',
    };
    return labels[state] || state || 'Not synced';
  };


  useEffect(() => {

    const userData = getDecryptData();
    if (userData?.username) setMYuser(userData.username);
    getUserOrders();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render


  return (
    <>

      <Header />

      <Helmet>
        <title> Account Order | {window.location.hostname}</title>

      </Helmet>

      {isLogin && <>
        <div className="user-dasboard whitesmoke" >

          <div className="container pt-4">
            <div className="row pb-4">

              <AccountSidebar />

              <div className="col-lg-9 my-lg-0 my-1">
                <div id="main-content" className="bg-white border">

                  <h4 className="text-uppercase">My Odoo orders</h4>



                  {isLoading ? (
                    // Display loading skeletons while data is being fetched
                    Array.from({ length: 2 }).map((_, index) => (
                      <div className="col-md-12" key={index}>

                        <div className="skeleton mb-3" style={{ height: 154, borderRadius: 2 }} />

                      </div>
                    ))
                  ) : Order.length === 0 ? (
                    <div className="bg-light-border p-4 text-center">
                      <h6 className="mb-1">No Odoo orders found</h6>
                      <p className="text-muted mb-0">Odoo synced orders for your account will appear here.</p>
                    </div>
                  ) :
                    (Order.map(Order => (
                      <>


                        <div className="order my-3 bg-light-border">
                          <div className="row">
                            <div className="col-lg-4">
                              <div className="d-flex flex-column justify-content-between order-summary">
                                <div className="d-flex align-items-center">
                                  <div className="text-uppercase">Odoo #{Order.odooOrder?.name || Order.odooOrderName || Order.odooOrderId}</div>
                                  <div className="blue-label ms-auto text-uppercase">
                                    {formatOdooState(Order.odooOrder?.state || Order.odooState)}
                                  </div>
                                </div>
                                <div className="fs-8 text-muted">
                                  Website Order #{Order.orderId}
                                </div>

                                <div className="fs-8"> {formatDate(Order.createdAt)}</div>

                              </div>
                            </div>
                            <div className="col-lg-8">
                              <div className="d-sm-flex align-items-sm-start justify-content-sm-between">
                                <div className="status">Website Status: {
                                  Order.status === '0' ? (<> Cancel </>) :
                                    Order.status === '1' ? 'Placed' :
                                      Order.status === '2' ? 'Accepted' :
                                        Order.status === '3' ? 'Packed' :
                                          Order.status === '4' ? 'Shipped' :
                                            Order.status === '5' ? 'Delivered' :
                                              'Unknown'
                                }</div>
                                {Order.odooOrder?.amount_total !== undefined && (
                                  <div className="status">
                                    Odoo Total: {Order.odooOrder?.currency_id?.[1] || ''} {Order.odooOrder.amount_total}
                                  </div>
                                )}
                                <Link className="btn btn-primary text-uppercase" to={`/account/order/${Order.userId || Order.user || currentUserId}/${Order._id}`}>
                                  order info
                                </Link>
                              </div>

                              <div className="progressbar-track">
                                <ul className="progressbar">
                                  <li id="step-1" className={`text-muted ${Order.status === '1' && 'green'}`}>
                                    <span class="ri-gift-line" />
                                  </li>
                                  <li id="step-2" className={`text-muted ${Order.status === '2' && 'green'}`}>
                                    <span className="ri-check-line" />
                                  </li>
                                  <li id="step-3" className={`text-muted ${Order.status === '3' && 'green'}`}>
                                    <span className="ri-instance-line" />
                                  </li>
                                  <li id="step-4" className={`text-muted ${Order.status === '4' && 'green'}`}>
                                    <span className="ri-truck-line" />
                                  </li>
                                  <li id="step-5" className={`text-muted ${Order.status === '5' && 'green'}`}>
                                    <span className="ri-box-1-line" />
                                  </li>
                                </ul>
                                <div id="tracker" />
                              </div>

                            </div>
                          </div>
                        </div>


                      </>
                    ))
                    )}


                </div>
              </div>
            </div>
          </div>

        </div>
      </>}




      <Footer />


    </>
  )
}

export default Account
